import { createContext } from "react";
let noteContext  = createContext();

export default noteContext;